import {
  AUTH_EMAIL_LOGIN,
  AUTH_PASSWORD_RESET_CONFIRMATION,
  AUTH_PASSWORD_SHOW
} from 'portal/constants/Routes';

import {
  buttonContainerStyles,
  buttonStyles,
  loginButtonStyles
} from 'auth/AuthStyles';
import { postData } from 'helpers/RequestHelper';
import { useSelector } from 'react-redux';
import Button from '@opploans/button-component/Button';
import React from 'react';
import RebrandEmail from 'fields/rebrand/RebrandEmail';

function PasswordResetEmailForm({ navigate }) {
  const email = useSelector((state) => state.email);
  const error = useSelector((state) => state.errors.email);
  const [loading, setLoading] = React.useState(false);

  const requestPasswordReset = async () => {
    const response = await postData({
      url: AUTH_PASSWORD_SHOW,
      body: {
        user: { email }
      }
    });
    if (response.data?.error) {
      window.toastr.error(response.data?.error);
      setLoading(false);
    }
    if (response.data?.redirect) {
      window.location.href = response.data.redirect;
      return;
    }
    if (response.data?.success) {
      window.location.href = AUTH_PASSWORD_RESET_CONFIRMATION;
    }
  };

  const onSubmit = async () => {
    setLoading(true);
    await requestPasswordReset();
  };

  return (
    <div
      role='button'
      aria-hidden='true'
      onKeyPress={(e) => {
        if (e.key === 'Enter' && email && !error) {
          onSubmit();
        }
      }}
    >
      <RebrandEmail
        additionalStyle={{
          width: '100%',
          '.MuiOutlinedInput-notchedOutline': {
            border: '1px solid #CACACA'
          }
        }}
        briteVerify={false}
      />
      <div css={buttonContainerStyles}>
        <Button
          css={[loginButtonStyles, { marginTop: '1rem' }]}
          onClick={onSubmit}
          loading={loading}
          disabled={!email || error}
        >
          Send Password Reset Link
        </Button>
        <Button css={buttonStyles} onClick={() => navigate(AUTH_EMAIL_LOGIN)}>
          Return to Login
        </Button>
      </div>
    </div>
  );
}

export default PasswordResetEmailForm;
